<template>
  <div
    v-if="showPopup"
    class="sticky-actions"
  >
    <naj-button
      class="incomplete-button"
      @click="showReasons"
    >
      <v-icon>mdi-information</v-icon>
      {{ local.lawsuitRequest.reasons.title }}
      <v-icon v-if="isExpanded">
        mdi-chevron-left
      </v-icon>
      <v-icon v-if="!isExpanded">
        mdi-chevron-down
      </v-icon>
    </naj-button>

    <v-expand-x-transition>
      <naj-box
        v-show="isExpanded"
        :title="`الاسباب ${reasonsRepliesDetails.length}`"
        :disable-collapsing="true"
        no-bottom-margin
        class="expand-card"
      >
        <div class="text-subtitle-2">
          {{ local.common.dearApplicant }}
        </div>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              v-for="(item, index) in reasonsRepliesDetails"
              :key="index"
            >
              {{ index + 1 }}. {{ item }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </naj-box>
    </v-expand-x-transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { requestStatus, requestReplyTypes } from '@/helpers/enum';
import najBox from '@/components/shared/naj-box.vue';

const { mapState, mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'RequestReasons',
  components: { najBox },
  props: ['requestObjectKey'],
  data() {
    return {
      isExpanded: false,
      requestReplyTypes,
      requestStatus,
    };
  },
  computed: {
    ...mapState({
      request: state => state.submittedRequestInfo,
      previousReplies: state => state.lawsuitRequest.previousReplies,
    }),
    reasonsRepliesDetails() {
      const reasons = this.previousReplies.filter(r =>
        r.requestReply == this.requestReplyTypes.PreviousRequestOnTheSameSubject.id ||
        r.requestReply == this.requestReplyTypes.PreviousLawsuitOnTheSameSubject.id ||
        r.requestReply == this.requestReplyTypes.RequestNotAvailable.id ||
        r.requestReply == this.requestReplyTypes.SaveRequest.id
      );
      if (reasons && reasons.length > 0) {
        return reasons.pop().details;
      }
      return [];
    },
    showPopup() {
      return (this.request.requestStatusId == requestStatus.previousRequestOnTheSameSubject ||
        this.request.requestStatusId == requestStatus.previousLawsuitOnTheSameSubject ||
        this.request.requestStatusId == requestStatus.requestNotAvailable ||
        this.request.requestStatusId == requestStatus.saved);
    },
  },
  methods: {
    ...mapActions(['getCasePreviousReplies', 'resetCasePreviousReplies']),
    showReasons() {
      this.isExpanded = !this.isExpanded;
    },
  },
  watch: {
    requestObjectKey(value) {
      if (value) {
        this.getCasePreviousReplies({
          objectKey: value,
          isCourtsRequestPreviousReplies: undefined,
        });
      } else {
        this.resetCasePreviousReplies();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_vars.scss';

::v-deep .v-button-wrapper .naj-button.primary {
  min-width: 248px !important;
  margin: -51px 31px -13px -15px !important;
}

.sticky-actions .expand-card {
  height: 248px !important;
}
.sticky-actions {
  position: fixed;
  left: 6px;
  top: 50%;
  z-index: 50;
  .v-button-wrapper.incomplete-button {
    transform: rotate(270deg);
    position: relative;
    right: 96px;

    .mdi-information {
      color: yellow;
      margin: 30px;
    }

    .mdi-chevron-left {
      color: white;
      transform: rotate(90deg);
    }
  }
  .expand-card {
    position: relative;
    float: left;
    bottom: 92px;
    width: 500px;
    height: 218px;

    .v-list-item {
      display: block !important;
      overflow-y: auto;
      max-height: 127px;

      .v-list-item__title {
        white-space: normal;
      }
    }

    .naj-modal-actions {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
